import { useEffect, useRef, useState } from "react";
import { Radio } from "antd";
import { Control, UseFormSetValue, useWatch } from "react-hook-form";
import "@/entities/journal";
import { SectionThirdFormType } from "../../model/types";
import { DocTypeEnum, DocTypeTypes } from "../../model/types/document-types";
import { SectionDocumentItem } from "./ui";
import "./section-document-list.scss";

interface SectionDocumentListProps {
  isInfo?: boolean;
  setValue?: UseFormSetValue<SectionThirdFormType>;
  isInfoView?: boolean;
  control: Control<SectionThirdFormType>;
  disabled?: boolean;
}

export const SectionDocumentList = ({
  isInfo,
  setValue,
  isInfoView,
  control,
  disabled = false,
}: SectionDocumentListProps) => {
  // eslint-disable-next-line react-compiler/react-compiler
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const docs =
    useWatch({
      control,
      name: "docs",
    }) || [];

  const [selectedMainType, setSelectedMainType] = useState<DocTypeEnum | null>(
    docs.some((doc) => doc.docType === DocTypeTypes.WORK_DOC)
      ? DocTypeTypes.WORK_DOC
      : DocTypeTypes.PROJECT_DOC,
  );

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current && docs.length > 0) {
      setSelectedMainType(
        docs.some((doc) => doc.docType === DocTypeTypes.WORK_DOC)
          ? DocTypeTypes.WORK_DOC
          : DocTypeTypes.PROJECT_DOC,
      );
      setTimeout(() => {
        isFirstRender.current = false;
      }, 1000);
    }
  }, [docs]);

  const handleTypeChange = (e: any) => {
    const newType = e.target.value;
    const previousType = selectedMainType;
    setSelectedMainType(newType);

    const filtered = docs.filter((doc) => doc.docType !== previousType);
    setValue?.("docs", filtered, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const isShowProjectDoc = selectedMainType === DocTypeTypes.PROJECT_DOC;

  return (
    <>
      <div className="journal-document-block-title">Документы</div>
      <div>
        {" "}
        {!isInfoView && (
          <Radio.Group
            onChange={handleTypeChange}
            value={selectedMainType || DocTypeTypes.PROJECT_DOC}
            style={{ marginBottom: 16 }}
            disabled={disabled}
          >
            <Radio value={DocTypeTypes.PROJECT_DOC}>
              Проектная документация
            </Radio>
            <Radio value={DocTypeTypes.WORK_DOC}>Рабочая документация</Radio>
          </Radio.Group>
        )}
      </div>

      {isShowProjectDoc ? (
        <SectionDocumentItem
          title="Проектная документация"
          docType={DocTypeTypes.PROJECT_DOC}
          setValue={setValue}
          isInfo={isInfo}
          control={control}
          checkErrorEnum={DocTypeTypes.PROJECT_DOC}
          disabled={disabled}
        />
      ) : (
        <SectionDocumentItem
          title="Рабочая документация"
          docType={DocTypeTypes.WORK_DOC}
          setValue={setValue}
          isInfo={isInfo}
          control={control}
          checkErrorEnum={DocTypeTypes.WORK_DOC}
          disabled={disabled}
        />
      )}

      <SectionDocumentItem
        title="Исполнительная схема"
        docType={DocTypeTypes.BUILT_SCHEME}
        setValue={setValue}
        isInfo={isInfo}
        control={control}
        disabled={disabled}
      />
      <SectionDocumentItem
        title="Исполнительный чертеж"
        docType={DocTypeTypes.BUILT_BLUEPRINT}
        setValue={setValue}
        isInfo={isInfo}
        control={control}
        disabled={disabled}
      />
      <SectionDocumentItem
        title="Нормативная документация"
        docType={DocTypeTypes.REGULATION_DOC}
        setValue={setValue}
        isInfo={isInfo}
        control={control}
        checkErrorEnum={DocTypeTypes.REGULATION_DOC}
        disabled={disabled}
      />
    </>
  );
};
